(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sauna-calorie-calculator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.sauna-calories-form');

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const heightFeet = parseFloat(event.target.height_feet.value);
      const heightInches = parseFloat(event.target.height_inches.value);
      const weight = parseFloat(event.target.weight.value);
      const saunaType = event.target.sauna_type.value;
      const time = parseFloat(event.target.time.value);

      const heightInInches = (heightFeet * 12) + heightInches;
      const heightInMeters = heightInInches * 0.0254;
      const weightInKg = weight * 0.453592;

      let mets = 0;
      switch (saunaType) {
        case 'infrared':
          mets = 2.5;
          break;
        case 'electric':
          mets = 3.5;
          break;
        case 'wood':
          mets = 4.5;
          break;
      }

      const caloriesBurned = (mets * weightInKg * (time / 60)).toFixed(2);
      document.getElementById('calories-burned-result').innerHTML =
        `🔥 You burned approximately <strong>${caloriesBurned}</strong> calories.`;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
